const BaseComponent = require('base/base-component');
const Server = require('helper/server');
const { overflowhidden } = require('helper/util');

class QHDetailPage extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .js-print': 'print'
      }
    });
    this.$iframe = this.$el.find('#iframe');
    this.$articleDetail = this.$el.find('[name=articleDetail]');
    this.articleDetail = JSON.parse(this.$articleDetail.val());
    const { title } = this.articleDetail;
    document.title=title;
    this.initQRCode();
    // 后台预览禁用点击
    this.initPreventClick();
    // 上报访问量
    this.initVisit();
    this.overflowAttachment();
  }

  initVisit () {
    Server
      .visitCount({ articleId: this.articleDetail.id })
      .done(({ article, total, today }) => {
        this.articleDetail.visitsCount = article;
        $('.counting .total').text(total);
        $('.counting .today').text(today);
      }).always(() => {
        this.initIframe();
      });
  }

  initQRCode () {
    const type = document.createElement('canvas').getContext ? 'canvas' : 'table';
    const appUrl = window.location.origin+"/app/detail/index.html?id="+this.articleDetail.id;
    console.log('appUrl', appUrl);
    this.$el.find('.qr-show .qr-code').qrcode({
      render: `${type}`,
      width: 100,
      height: 100,
      text: appUrl,
    });
  }

  initIframe () {
    this.$iframe.on('load', () => {
      this.resizeIframe();
    });
    const doc = this.$iframe.get(0).contentDocument;
    doc.open();
    doc.write(this.buildTemplate());
    doc.close();
  }

  /**
   * 根据iframe中的内容动态调整iframe的高度
   */
  resizeIframe () {
    const iframeBodyHeight = this.$iframe.get(0).contentDocument.body.scrollHeight;
    this.$iframe.height(iframeBodyHeight + 40 + 'px');
  }

  /**
   * 构建文章内容的html，用于填充到iframe中
   */
  buildTemplate () {
    const { content, author, documentNo, publishDate = '', visitsCount = 0, title } = this.articleDetail;
    const processedContent = content
      .replace(/contenteditable="true"/g, '')
      .replace(/<section/g, '<div') // section替换为div，兼容ie8
      .replace(/<\/section>/g, '</div>');
    return (
      `
    <!DOCTYPE html>
      <html xmlns='http://www.w3.org/1999/xhtml' class='view'>
      <head>
        <style type='text/css'>.view{padding:0;word-wrap:break-word;cursor:text;height:90%;}.view:after {clear:both;content:'';display:block;width: 0;height: 0;visibility:hidden;}body{margin:8px;font-family:sans-serif;font-size:16px;}p{margin:5px 0;}
        </style>
        <style>
          img {
            max-width: 100%;
          }
          p{
            line-height: 2em;
          }
        </style>
        <style id="table">.selectTdClass{background-color:#edf5fa !important}table.noBorderTable td,table.noBorderTable th,table.noBorderTable caption{border:1px dashed #ddd !important}table{margin-bottom:10px;border-collapse:collapse;display:table;page-break-inside:auto;}tr{page-break-inside:avoid;page-break-after:auto;}thead{ display:table-header-group;}tfoot{display:table-footer-group;}td,th{padding: 5px 10px;border: 1px solid #DDD;}caption{border:1px dashed #DDD;border-bottom:0;padding:3px;text-align:center;}th{border-top:1px solid #BBB;background-color:#F7F7F7;}table tr.firstRow th{border-top-width:2px;}.ue-table-interlace-color-single{ background-color: #fcfcfc; } .ue-table-interlace-color-double{ background-color: #f7faff; }td p{margin:0;padding:0;}</style>
        <style id="list">ol,ul{margin:0;padding:0;width:95%}li{clear:both;}.list-paddingleft-1{padding-left:0}.list-paddingleft-2{padding-left:30px}.list-paddingleft-3{padding-left:60px}</style>
        <style id="pre">pre{margin:.5em 0;padding:.4em .6em;border-radius:8px;background:#f8f8f8;}</style>
        <style>.detail-info{font-size: 14px;color: #666;padding: 10px 0;margin-bottom: 20px;border-bottom: 1px dotted #999;}.detail-info span{margin-right: 20px;white-space: nowrap;}</style>
        <style>.fjxx{box-sizing:border-box;}</style>
        <style>.template-law{font-size:14px;}.law-info{width:100%;background:#f9f9f9;border:1px solid #eee;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-info > tbody > tr > td{padding:5px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100px;}.law-info > tbody > tr > td p{max-width:190px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}.law-info .text-right{text-align:right;}.law-info .info_title{height:32px;font-size:16px;color:#f00;font-weight:bold;text-align:center;}.law-info td,th{border:0;}.law-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-title h1{width:100%;text-align:center;font-size:40px;color:#f00;text-decoration:none;font-weight:bold;margin-bottom:60px;margin:0;padding:120px 0 60px 0;}.law-title h2{border-bottom:#f00 solid 3px;line-height:50px;font-size:17px;color:#000;text-decoration:none;font-weight:normal;height:50px;width:100%;text-align:center;padding:0;margin:0 0 40px 0;}.law-title p{font-size: 20px;padding-bottom:15px;}</style>
      </head>
      <body class='view' style="overflow-y:hidden;">
      <header>
        <h1 style="text-align:center;line-height: 30px;font-size: 24px;font-weight: 500;">${this.htmlEncodeByRegExp(title)}</h1>
        <p class="detail-info" style="text-align:center;">
          <span>来源：${this.htmlEncodeByRegExp(author)}</span>
          ` +
      (documentNo ? `<span>文号：${this.htmlEncodeByRegExp(documentNo)}</span>` : '') +
      `<span>发布时间：${publishDate}</span>
          <span>浏览次数：${visitsCount}</span>
        </p>
      </header>
      ${processedContent}
      </body>
    </html>`
    );
  }

  /** */
  htmlEncodeByRegExp (str = '') {
    let s = '';
    if (!str || str.length == 0) {
      return '';
    }
    s = str.replace(/</g, '&lt;');
    s = s.replace(/>/g, '&gt;');
    return s;
  }

  /**
   * 打印文章
   */
  print () {
    const frameWindow = this.$iframe.get(0).contentWindow;

    const callPrint = () => {
      // Fix for IE : Allow it to render the iframe
      frameWindow.focus();
      try {
        // Fix for IE11 - printng the whole page instead of the iframe content
        if (!frameWindow.document.execCommand('print', false, null)) {
          // document.execCommand returns false if it failed -http://stackoverflow.com/a/21336448/937891
          frameWindow.print();
        }
        // focus body as it is losing focus in iPad and content not getting printed
        $('body').focus();
      } catch (e) {
        frameWindow.print();
      }
    };
    setTimeout(callPrint, 50);
  }

  /**
   * 后台预览禁用点击
   */
  initPreventClick () {
    if (location.hostname.indexOf('zxtmp') >= 0 || location.hostname.indexOf('cms') >= 0) {
      document.body.addEventListener('click', (e) => {
        e.preventDefault();
        return false;
      }, true);
    }
  }

  overflowAttachment () {
    const $attachment = this.$el.find('.attachment');
    if ($attachment) {
      $.map($attachment.find('li .name'), (el) => {
        const $el = $(el);
        overflowhidden($el[0], 2, $el.attr('title'));
      });
    }
  }
}

module.exports = QHDetailPage;
